module.exports = __webpack_public_path__ + "img/visaelectron.cac8331.png";